module.exports = {
  account: [
    {
      username: "admin",
      password: "admin123",
      apiKey: "argos20240512a049f8c83cd7ea7b2ss",
    },
    {
      username: "user_001",
      password: "P@ssw0rd123",
      apiKey: "c3075c1e1ee348ceb105606fb7ad1cb3",
    },
    // {
    // 	username: "user_002",
    // 	password: "Qwerty!456",
    // 	apiKey: "027f82d276ac4e0fb5be3d007121eef8",
    // },
    {
      username: "user_003",
      password: "12345AbC!",
      apiKey: "221038bc4e824de0b6899d9839922a0a",
    },
    {
      username: "user_010",
      password: "q3D8sF2gH5",
      apiKey: "81b0a9b6e486409b8b1988195b4d34c7",
    },
    {
      username: "user_011",
      password: "Y7kP3sQ9dF",
      apiKey: "ab3c0c83c84e4ff595f7d95e77907a37",
    },
    {
      username: "user_012",
      password: "4GtR8mB2vX",
      apiKey: "fc507d9f4fa54398a07e535d85fc3fff",
    },
    {
      username: "user_013",
      password: "L6cN1wH5jZ",
      apiKey: "4affaaa390b4400fabfc2df3c4d2b2dd",
    },
    {
      username: "user_014",
      password: "3Sf7Dk9Tg2",
      apiKey: "462b59fef40b4551baf55b09faa8edce",
    },
    {
      username: "user_015",
      password: "Q5vC8mX2p7",
      apiKey: "a7302da98cab405f9cdfb9ea35f3a8eb",
    },
    // {
    // 	username: "user_016",
    // 	password: "Jh9Ld4Fc6g",
    // 	apiKey: "b5c0d62afc3a48a9bba4c3c22d114499",
    // },
    // {
    // 	username: "user_017",
    // 	password: "P2rT7bY5kC",
    // 	apiKey: "ff61e3c529be4acd9295079b0f431f52",
    // },
    // {
    // 	username: "user_018",
    // 	password: "We3Rf6Tg8h",
    // 	apiKey: "0762b944375f4160903fa350f3fc5708",
    // },
    // {
    // 	username: "user_019",
    // 	password: "N9mK3jH7dS",
    // 	apiKey: "25b66d4c786b400fa11e51dd3e4aad73",
    // },
    // {
    // 	username: "user_020",
    // 	password: "B5vCf2Dg9e",
    // 	apiKey: "f47ec63589c84a5d9a7412cbeea7e829",
    // },
    // {
    // 	username: "user_021",
    // 	password: "8KpL4qR6sT",
    // 	apiKey: "f3e221ac79f84fcc9bcdb19da4ed0ed5",
    // },
    // {
    // 	username: "user_022",
    // 	password: "Fd5Gv2Hj8k",
    // 	apiKey: "b7d3b1926cda48b5bf92bda27218d0d0",
    // },
    // {
    // 	username: "user_023",
    // 	password: "M3tN7wB1yE",
    // 	apiKey: "461810797017418aa19b0c23722b9a12",
    // },
    {
      username: "user_024",
      password: "Sg9Dk4Rf6t",
      apiKey: "21c21887f374418a8777f901882a657c",
    },
    {
      username: "user_025",
      password: "Q2cV5mX8p3",
      apiKey: "91bee719170b47b9872317e6004cd3ee",
    },

    {
      username: "user_035",
      password: "Q1r3S5t7U9",
      apiKey: "846d7cbf3e8a4905ac4e13f37e34c0d5",
    },
    {
      username: "user_036",
      password: "5Vw7Xy9zB2",
      apiKey: "c65af0804df742f582ccfae95178ddd0",
    },
    {
      username: "user_037",
      password: "a4C6d8E0f2",
      apiKey: "5f94c76e73a8494ca015fc2c78bc592f",
    },

    {
      username: "K0001",
      password: "K9bF2qR5sT",
      apiKey: "c8319d2f042b414bbbd261ac2c13e0e0",
    },
    {
      username: "E0001",
      password: "3JhL7xP1dZ",
      apiKey: "32399a1f842548c6a53730d99245a826",
    },
    // {
    // 	username: "user_032",
    // 	password: "3Fg5Hj7kL9",
    // 	apiKey: "420436e91354479f963d054e98d12bbd",
    // },
    // {
    // 	username: "user_033",
    // 	password: "d8E6f1G3h5",
    // 	apiKey: "2466822e404449e689c81a597382b240",
    // },
    {
      username: "K0002",
      password: "7ZkP3rT9wQ",
      apiKey: "d7267439ddfc42ae958c8df016bd1a4f",
    },
    {
      username: "E0002",
      password: "2XfB8sJ5dL",
      apiKey: "05771fbac35c4e3a9fb0a4352d13e3b2",
    },
    {
      username: "K0003",
      password: "pQ72kG9tR5",
      apiKey: "c9f6552fa84a466cb5d823f02654e247",
    },

    {
      username: "user_043",
      password: "97f3cd0edb",
      apiKey: "3fe1cb7aa85e4be6bcc965339137504f",
    },
    {
      username: "user_044",
      password: "b3e258ab90",
      apiKey: "f34354909d2f45c4855a700241c2d2c1",
    },

    {
      username: "user_049",
      password: "5bb26e8432",
      apiKey: "e10122b9edf9427ea35808dbd737b040",
    },

    {
      username: "user_058",
      password: "4a7fa105e8",
      apiKey: "a3be1c65c8584ce78bb1e75263d56cb0",
    },
    {
      username: "user_059",
      password: "1c0d0e47b9",
      apiKey: "9789b999895340c2a5544850cf28295a",
    },
    {
      username: "user_060",
      password: "bc00c62beb",
      apiKey: "ade5917da3824412be253f2537a3d126",
    },
    {
      username: "user_061",
      password: "fa21313fd4",
      apiKey: "cc9bdb9c221d49bba048ab5b0e6f5f61",
    },
    {
      username: "user_062",
      password: "3f4e1e704e",
      apiKey: "11abce00011a47abb12ea46fd9f4386f",
    },
    {
      username: "user_063",
      password: "bba4628412",
      apiKey: "bb49465e2932474eb944ed159f496f63",
    },
    {
      username: "user_064",
      password: "d743f1768a",
      apiKey: "a1362ffb71db4a6ea2e3898f15e2b03f",
    },
    {
      username: "user_065",
      password: "fd685cdf3a",
      apiKey: "221d64070f844f468bdc9da69af4dc9b",
    },
    {
      username: "user_066",
      password: "682871e418",
      apiKey: "7954672d96cc46ad8aa4baca222cef67",
    },
    {
      username: "user_067",
      password: "ec01a28c24",
      apiKey: "92b8ee8825e54db4aa9e73fd98734720",
    },
    {
      username: "user_068",
      password: "6f25908681",
      apiKey: "a6d617554fd2405d8da314470bc96ced",
    },
    {
      username: "user_069",
      password: "e365c46efa",
      apiKey: "ed5cefe5201a46afad1edc7f6d789a0b",
    },
    {
      username: "user_070",
      password: "eb15bc574e",
      apiKey: "33016c8a4c284d55b4207970ecdc1cf7",
    },
    // 2026-05-28 新增
    {
      username: "user_071",
      password: "33d6adc635",
      apiKey: "4826b6c53517443eb44736d316923e52",
    },
    {
      username: "user_072",
      password: "67d316f0e8",
      apiKey: "864ff42c00fe472e9368cbaec09699ee",
    },
    {
      username: "user_073",
      password: "4b0cf0571f",
      apiKey: "7fa3a248203d463a991b31d292f33a9c",
    },
    {
      username: "user_074",
      password: "e9ff9e82e0",
      apiKey: "c235fb2a68de4db597dd1f486a0bd4ad",
    },
    {
      username: "user_075",
      password: "783770decd",
      apiKey: "ae76b940158b4461909af405ba7bce35",
    },
    {
      username: "user_076",
      password: "b004d34e96",
      apiKey: "0dadc1720b194e11b616b3d2581f8ae2",
    },
    {
      username: "user_077",
      password: "7a7382d9fb",
      apiKey: "538631ef217344f288547231ecbec2c6",
    },
    {
      username: "user_078",
      password: "7ccfafd5c4",
      apiKey: "62486e97e5f244f784c787a2a86e21c1",
    },
    {
      username: "user_079",
      password: "7200c64dbe",
      apiKey: "553e125213274099acd28fcbfe6267f4",
    },
    {
      username: "user_080",
      password: "fd3a09c49e",
      apiKey: "a351b0af6a804705bc7f8a998488230b",
    },
    {
      username: "user_081",
      password: "10fffeac62",
      apiKey: "3ded17bb30994efd96155082d11ab509",
    },
    {
      username: "user_082",
      password: "e4ee071659",
      apiKey: "f1c133ed499b4149a69add750dc5efe3",
    },
    {
      username: "user_083",
      password: "a40f2732d5",
      apiKey: "0bfa457bc5f64bdeb25d2c5c670b775b",
    },
    {
      username: "user_084",
      password: "7f31d5b4d4",
      apiKey: "eb7ad49a60fc4afe96c2374a210b2fa5",
    },
    {
      username: "user_085",
      password: "ed3b2a76af",
      apiKey: "4215e80899bb4c09af04c5e283885ea3",
    },
    {
      username: "user_086",
      password: "59bb19552a",
      apiKey: "d2010be6abf14762815b4d50cf344b8e",
    },
    {
      username: "user_087",
      password: "d2762f0e04",
      apiKey: "5c899b389d524705810ba4f75dd750d2",
    },
    {
      username: "user_088",
      password: "721aa1a557",
      apiKey: "6a2656cb3cd04bd48a235514f99dd640",
    },
    {
      username: "user_089",
      password: "25ffa91812",
      apiKey: "7e957c6d085949a78e29ad36c80a7fa0",
    },
    {
      username: "user_090",
      password: "84634e9ffe",
      apiKey: "3f1ede078c624b6dba637fad41c8d8ce",
    },
    {
      username: "user_091",
      password: "96b899391d",
      apiKey: "fae6aed8c37a4cd0b7a55f03d6da2d64",
    },
    {
      username: "user_092",
      password: "b026e7141e",
      apiKey: "997abe61b67c4385ac75a4a645be4e81",
    },
    {
      username: "user_093",
      password: "f130bde209",
      apiKey: "ac4fc94ca3c44610b1e623b335734659",
    },
    {
      username: "user_094",
      password: "d86fbc163b",
      apiKey: "72b7e9e4334a479888629952b00c8f92",
    },
    {
      username: "user_095",
      password: "498acddc5d",
      apiKey: "914974fea44b4649868cb38a0aadc0d8",
    },
    {
      username: "user_096",
      password: "b9e050c3e9",
      apiKey: "a359b0246f6e4251b77d1d4bf4f52f60",
    },
    {
      username: "user_097",
      password: "2d7a61bae3",
      apiKey: "36a3fafa15d5484d84f91889841aaca7",
    },
    {
      username: "user_098",
      password: "dfb1390c49",
      apiKey: "33e3de713cd94536a2e533903053d8c0",
    },
    {
      username: "user_099",
      password: "b506fbc99a",
      apiKey: "ba49cf3941d74500871c795f45508f48",
    },
    {
      username: "user_100",
      password: "14106f8896",
      apiKey: "47f760a37d234c56b1e2c0941f1bd928",
    },
    {
      username: "K0004",
      password: "6e892c02f8",
      apiKey: "6aa56e322c4f4760b326bf7b950986c2",
    },
    {
      username: "user_101",
      password: "29cc0e9e79",
      apiKey: "ee9e5f33cc0c4eebb373f167d52ff736",
    },
    //
    {
      username: "user_102",
      password: "6e6fee7bae",
      apiKey: "f6c5901c002a4727a143ae91be47fa6e",
    },
    {
      username: "user_103",
      password: "78dcc7151b",
      apiKey: "3ba8a31072714ac9972828613980afce",
    },
    {
      username: "user_104",
      password: "6c497d7cca",
      apiKey: "8e86a75eefae405e82865195924883b3",
    },
    {
      username: "user_105",
      password: "d87e0eec28",
      apiKey: "f0870fdc3fe24d5bb7d284aa4d90186f",
    },
    {
      username: "user_106",
      password: "8d51751564",
      apiKey: "8b140c3c6f3346dbb5cd99414a88d6a9",
    },
    {
      username: "user_107",
      password: "737cc8a3eb",
      apiKey: "d69ac3fd4fef4a5f8c6f288ba5f53f55",
    },
    {
      username: "user_108",
      password: "7aa86b7568",
      apiKey: "8a68579fa4fb458a94585fdd4a4cb161",
    },
    {
      username: "user_109",
      password: "90a70473d1",
      apiKey: "e4eda6b6bf23407091106af4543cbb8d",
    },
    {
      username: "user_110",
      password: "95f140806d",
      apiKey: "cac9f11a75aa4a338da5b39949a4b0ae",
    },
    {
      username: "user_111",
      password: "a8edd70e74",
      apiKey: "448acf81f23a481ab32d4dd00cffdbf7",
    },
    {
      username: "user_112",
      password: "cb590e5f3c",
      apiKey: "4bf52dff51a04875a7132077d8bfc789",
    },
    {
      username: "user_113",
      password: "c930de9a2a",
      apiKey: "2543dfd977314f6bb6905c9e0749b889",
    },
    {
      username: "user_114",
      password: "4cee752cdf",
      apiKey: "f429f5ace0344ebfa7426900b422da28",
    },
    {
      username: "user_115",
      password: "bd37c7c60e",
      apiKey: "74fc4a84153441d192d048238257ac32",
    },
    {
      username: "user_116",
      password: "99a8adc8ea",
      apiKey: "5efb06d1b2534bcfaaf73051e5ff17d5",
    },
    {
      username: "user_117",
      password: "205125961b",
      apiKey: "45c9f3e52a5747288b50c41e7b6966cd",
    },
    {
      username: "user_118",
      password: "9d582a2117",
      apiKey: "82adbfa7dfd24b25afc0c05a2fbc13d9",
    },
    {
      username: "user_119",
      password: "97faf50096",
      apiKey: "2f086fa3caac4c7bb2ee52375378c6a2",
    },
    {
      username: "user_120",
      password: "5fb81b16ef",
      apiKey: "f5ae1cc1401e4d828074138d0378e863",
    },
  ],
};
